module.exports = __webpack_public_path__ + "img/img1.86e1efa9.png";